// lib
import React, { memo, ReactElement, useCallback, useEffect, useState } from "react";

// styles
import styles from "../styles/VoiceDirectionTooltip.scss";

// internal deps
import { Image, ElementObserver, AriaHidden } from "@swiggy-private/core-ui";

// constants
import { TEXTS, ICONS } from "@cart-ui/constants";

export interface VoiceDirectionsTooltipProps {
    onVoiceDirectionTooltipImpression: (displayText: string) => void;
}

const ICON_SIZE = 24 * 3;

const VoiceDirectionTooltip = ({ onVoiceDirectionTooltipImpression }: VoiceDirectionsTooltipProps): ReactElement => {
    const [showToolTip, setShowTooltip] = useState<boolean>(false);

    const updateTooltipState = useCallback(() => {
        setShowTooltip(true);
    }, []);

    useEffect(() => {
        if (showToolTip) {
            onVoiceDirectionTooltipImpression(TEXTS.VOICE_DIRECTIONS_TOOLTIP);
        }
    }, [showToolTip, onVoiceDirectionTooltipImpression]);

    return (
        <>
            <ElementObserver onViewEnter={updateTooltipState} className={styles.tooltipSensor}>
                <div />
            </ElementObserver>
            {showToolTip && (
                <AriaHidden as="div" className={styles.tooltip}>
                    <div className={styles.content}>
                        <Image
                            className={styles.contentImg}
                            imageId={ICONS.VOICE_DIRECTIONS_TOOLTIP}
                            width={ICON_SIZE}
                            height={ICON_SIZE}
                        />
                        <p className={styles.contentText}>{TEXTS.VOICE_DIRECTIONS_TOOLTIP}</p>
                    </div>
                </AriaHidden>
            )}
        </>
    );
};

export default memo(VoiceDirectionTooltip);
